import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles/index.css';
import Home from './pages/Home';
import Biography from './pages/Biography';
import Repertory from './pages/Repertory'; 
import ProjectB from './pages/Videos';
import Teaching from './pages/Teaching';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/biography" element={<Biography />} />
        <Route path="/repertory" element={<Repertory />} />
        <Route path="/project-b" element={<ProjectB />} />
        <Route path="/teaching" element={<Teaching />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();